import { UNBLOCK_USER_API_ENDPOINT } from "../../constants/config";
import { useMutation } from "@tanstack/react-query";
import { getAuthToken } from "../../hooks/useAuth";

export const unblockUser = async ({
  admission_id,
  product_id,
  tenant_id
}) => {
  const response = await fetch(UNBLOCK_USER_API_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${getAuthToken()}`,
      "product-id": product_id,
      "tenant-id": tenant_id,
      platform: "web",
    },
    body: JSON.stringify({ admission_id }),
  });
    
    
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Failed to unblock user");
  }
  return data;
};

export function useUnblockUser() {
  return useMutation({
    mutationFn: unblockUser,    
  });
}
